import React, { useRef, useState, useEffect } from "react";
import LineChartWithPointWorkflow from "../component/common-component/LineChartWithPointWorkflow";
import pinned from "../assets/images/Pinned.svg";
import unpinned from "../assets/images/Unpin.svg";
import { default as infoIcon } from "../assets/images/Info icon.svg";
import activestatus from "../assets/images/activeStatus.svg";
import inactivestatus from "../assets/images/inactivestatus.svg";
import { Button, Overlay, Tooltip } from "react-bootstrap";
import WorflowDescription from "../component/common-component/WorflowDescription";
import moment from "moment";
import { apiCall } from "../services/AxiosService";
import { API_URL } from "../services/APIRoute";
import { apiResponse } from "../services/APIResponse";
import { toast } from "react-toastify";
import { commonservices } from "../services/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import supportmodule from "../assets/images/supportmodule.svg";

import {
  UpdateWorkFlowRunningStatus,
  UpdateWorkFlowStatus,
} from "../services/ReduxTookit/Slice/WorkFlowRedux";
import SupportModel from "../component/Workflow/FlowNewModels/SupportModel";

const WorkFlowStatusModel = ({
  NetworkUsageChart,
  MemoryUsageChart,
  CPUUsageChart,
  id,
  NewMachineInfo,
  FnForsetIsWorkFlowIsRunning,
  IsWorkFlowIsRunning,
  FnForsetActiveRightSidePanel,
  activeRightSidePinnedPanel,
  FnForsetActiveRightSidePinnedPanel,
  flowDetails,
  BindDataByID,
  FunForsetActiveSidePanelPinned,
  FunForsetActiveSidePanel,
  laststatus,
  isViewMode,
}) => {
  const dispatch = useDispatch();
  let Userdata = useSelector((state) => state.userinfo.UserInfo);
  const [loadingState, setLoadingState] = useState(false);
  const [supportShowModel, setSupportShowModel] = useState(false);
  const [workFlowDiscriptionPopupstate, setworkFlowDiscriptionPopupstate] =
    useState(false);
  const workFlowDiscriptionPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setworkFlowDiscriptionPopupstate(!workFlowDiscriptionPopupstate);
  };

  const MachineSetupInfo = useRef(null);
  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  useEffect(() => {
    setLoadingState(false);
  }, [laststatus]);

  const fnRunworkflow = async (state) => {
    FunForsetActiveSidePanelPinned(false);
    FunForsetActiveSidePanel(false);
    if (flowDetails?.workflowkey) {
      FnForsetIsWorkFlowIsRunning(true);
      setLoadingState(true);
      let body = {
        workflowid: flowDetails?.workflowid,
        status: state,
      };
      // let resData = await apiCall(
      //   {
      //     method: "POST",
      //     url:
      //       state === "run"
      //         ? API_URL.BASEURL + API_URL.WORKFLOW.UPDATE_WORKFLOW_STATUS
      //         : API_URL.BASEURL +
      //           API_URL.WORKFLOW.UPDATE_WORKFLOW_RUNNING_STATUS,
      //     body: body,
      //   },
      //   true
      // );
      // let res = apiResponse(false, resData);
      if (state === "run") {
        dispatch(UpdateWorkFlowStatus(body)).then((res) => {
          if (res?.payload?.isValidate) {
            BindDataByID(id);
            setLoadingState(false);
          } else {
            FnForsetIsWorkFlowIsRunning(false);
            setLoadingState(false);
          }
        });
      } else {
        dispatch(UpdateWorkFlowRunningStatus(body)).then((res) => {
          if (res?.payload?.isValidate) {
            BindDataByID(id);
            setLoadingState(false);
          } else {
            FnForsetIsWorkFlowIsRunning(false);
            setLoadingState(false);
          }
        });
      }
    } else {
      toast.error("Workflow Key Is Missing!!");
    }
  };

  //#region Close ToolTip / Overlays Outside Click ----------------------

  const overlayDesc_Ref = useRef(null);

  const handleOutsideClick = (event) => {
    if (
      overlayDesc_Ref.current &&
      !overlayDesc_Ref.current.contains(event.target) &&
      !MachineSetupInfo.current.contains(event.target)
    ) {
      workFlowDiscriptionPopup(event); // Close the overlay
    }
  };

  useEffect(() => {
    if (workFlowDiscriptionPopupstate) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [workFlowDiscriptionPopupstate]);

  //#endregion ----------------------

  return (
    <div className="project-view-summary-sec-main project-view-cost-summary-sec-main">
      <div className="summary-title flowstatus-title cursor-pointer">
        <div className="work-flow-status-title">
          <h3
            onClick={() =>
              FnForsetActiveRightSidePanel(activeRightSidePinnedPanel)
            }
          >
            Workflow Status
          </h3>
          {commonservices.getStatus(flowDetails?.argoworkflowstatus)}

          {/* {flowDetails?.workflowkey && (
                        <>
                            {flowDetails?.laststatus &&
                                (flowDetails?.laststatus?.toUpperCase() === "RUNNING" ||
                                    flowDetails?.laststatus?.toUpperCase() === "SUSPEND" ||
                                    flowDetails?.laststatus?.toUpperCase() === "RESUME") ? (
                                <>
                                    {loadingState ? (
                                        <span className="red-btn-badge p-2">Loading...</span>
                                    ) : (
                                        <span
                                            className="red-btn-badge"
                                            onClick={() => fnRunworkflow("stop")}
                                        >
                                            Stop
                                        </span>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                            {flowDetails?.laststatus &&
                                flowDetails?.laststatus?.toUpperCase() === "STOP" ? (
                                <>
                                    {loadingState ? (
                                        <span className="red-btn-badge">Loading...</span>
                                    ) : (
                                        <span
                                            className="red-btn-badge"
                                            onClick={() => fnRunworkflow("delete")}
                                        >
                                            Delete
                                        </span>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                        </>
                    )} */}
        </div>

        {!isViewMode && (
          <img
            className="workflow-pin-icon"
            src={activeRightSidePinnedPanel === "summary" ? pinned : unpinned}
            alt="analatics"
            onClick={() =>
              activeRightSidePinnedPanel === "summary"
                ? FnForsetActiveRightSidePinnedPanel("sm-panel")
                : FnForsetActiveRightSidePinnedPanel("summary")
            }
          />
        )}
      </div>
      <div className="summary-body">
        <div
          className={
            flowDetails?.argoworkflowstatus?.toUpperCase() !== "DRAFT"
              ? "workflow-status-inner-top"
              : ""
          }
        >
          <h3>{flowDetails?.argoworkflowstatus === "Active" && "Next Run"}</h3>
          <div className="workflow-status-inner-top-inner">
            <div>
              <h2>
                {flowDetails?.nextrunon &&
                  commonservices.convertTimeToLocal(flowDetails?.nextrunon)}
              </h2>
              <p>
                {flowDetails?.nextrunon &&
                  commonservices.convertDateToLocal(flowDetails?.nextrunon)}
              </p>
            </div>
            {/* {parseInt(id) !== 0 && (
                            <>
                                {flowDetails?.workflowkey && (
                                    <>
                                        {flowDetails?.argoworkflowstatus?.toUpperCase() ===
                                            "DRAFT" ? (
                                            <></>
                                        ) : (
                                            <>
                                                {flowDetails?.laststatus &&
                                                    (flowDetails?.laststatus?.toUpperCase() === "NEW" ||
                                                        flowDetails?.laststatus?.toUpperCase() ===
                                                        "PARTIAL SUCCESS" ||
                                                        flowDetails?.laststatus?.toUpperCase() === "DELETE" ||
                                                        flowDetails?.laststatus?.toUpperCase() ===
                                                        "COMPLETED" ||
                                                        flowDetails?.laststatus?.toUpperCase() ===
                                                        "FAILED") ? (
                                                    <>
                                                        {loadingState ? (
                                                            <button className="green-btn run-btn-dimension">
                                                                Loading...
                                                            </button>
                                                        ) : (
                                                            <button
                                                                className="green-btn run-btn-dimension"
                                                                onClick={() => {
                                                                    fnRunworkflow("run");
                                                                    FnForsetActiveRightSidePinnedPanel("summary");
                                                                }}
                                                            >
                                                                Run Now
                                                            </button>
                                                        )}
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                            </>
                                        )}
                                        {flowDetails?.laststatus &&
                                            flowDetails?.laststatus?.toUpperCase() === "SUSPEND" ? (
                                            <>
                                                {loadingState ? (
                                                    <button className="green-btn run-btn-dimension">
                                                        Loading...
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="green-btn run-btn-dimension"
                                                        onClick={() => fnRunworkflow("resume")}
                                                    >
                                                        Resume
                                                    </button>
                                                )}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                        {flowDetails?.laststatus &&
                                            flowDetails?.laststatus?.toUpperCase() === "RUNNING" ? (
                                            <>
                                                {loadingState ? (
                                                    <button className="green-btn run-btn-dimension">
                                                        Loading...
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="green-btn run-btn-dimension"
                                                        onClick={() => fnRunworkflow("suspend")}
                                                    >
                                                        Suspend
                                                    </button>
                                                )}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                )}
                            </>
                        )} */}
          </div>
        </div>
        <div className="workflow-status-inner-main-content">
          <div className="d-flex justify-content-between">
            {NewMachineInfo?.name && (
              <>
                <span className="mt-0">
                  {commonservices.truncateText(NewMachineInfo?.name, 23)}
                  <span
                    className="ms-2"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      handleOverlay(e);
                      setworkFlowDiscriptionPopupstate(
                        !workFlowDiscriptionPopupstate
                      );

                      workFlowDiscriptionPopup();
                    }}
                    ref={MachineSetupInfo}
                  >
                    <img
                      style={{ width: "18px" }}
                      src={infoIcon}
                      alt="infoIcon"
                    />
                  </span>

                  {workFlowDiscriptionPopupstate ? (
                    <>
                      <Overlay
                        ref={overlayDesc_Ref}
                        target={MachineSetupInfo.current}
                        show={workFlowDiscriptionPopupstate}
                        placement="bottom"
                      >
                        {(props) => (
                          <Tooltip id="overlay-example" {...props}>
                            <WorflowDescription
                              handleshowPopup={workFlowDiscriptionPopup}
                              data={NewMachineInfo?.desc}
                            />
                          </Tooltip>
                        )}
                      </Overlay>
                    </>
                  ) : (
                    ""
                  )}
                </span>

                <div
                  className="filtering-main tourWorkflowLogs"
                  onClick={() => setSupportShowModel(true)}
                >
                  <img src={supportmodule} alt="supportmodule" />
                  <span>Support</span>
                </div>
              </>
            )}
          </div>
          <div className="workflow-status-inner-main-content-chart-with-title-main">
            <div className="workflow-status-inner-main-content-chart-with-title-single">
              {CPUUsageChart.datasets &&
                CPUUsageChart.datasets.length > 0 &&
                CPUUsageChart.datasets[0].data &&
                CPUUsageChart.datasets[0].data.length > 0 && (
                  <>
                    <h5>CPU Usage</h5>
                    <div className="workflow-status-inner-main-content-chart-with-title-single-chart">
                      <LineChartWithPointWorkflow
                        data={{
                          labels: CPUUsageChart.labels,
                          datasets: CPUUsageChart.datasets,
                        }}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                          plugins: {
                            legend: {
                              display: false,
                            },
                            tooltip: {
                              display: true,
                            },
                          },
                          scales: {
                            x: {
                              display: false,
                              grid: {
                                display: true,
                                offset: false,
                              },
                              ticks: {
                                align: "center",
                              },
                            },
                            y: {
                              display: false,
                              grid: {
                                display: false,
                              },
                            },
                          },
                          elements: {
                            point: {
                              radius: 0,
                            },
                          },
                        }}
                      />
                    </div>
                  </>
                )}
            </div>
            <div className="workflow-status-inner-main-content-chart-with-title-single">
              {MemoryUsageChart.datasets &&
                MemoryUsageChart.datasets.length > 0 &&
                MemoryUsageChart.datasets[0].data &&
                MemoryUsageChart.datasets[0].data.length > 0 && (
                  <>
                    <h5>Memory Usage</h5>
                    <div className="workflow-status-inner-main-content-chart-with-title-single-chart">
                      <LineChartWithPointWorkflow
                        data={{
                          labels: MemoryUsageChart.labels,
                          datasets: MemoryUsageChart.datasets,
                        }}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                          plugins: {
                            legend: {
                              display: false,
                            },
                            tooltip: {
                              display: true,
                            },
                          },
                          scales: {
                            x: {
                              display: false,
                              grid: {
                                display: true,
                                offset: false,
                              },
                              ticks: {
                                align: "center",
                              },
                            },
                            y: {
                              display: false,
                              grid: {
                                display: false,
                              },
                            },
                          },
                          elements: {
                            point: {
                              radius: 0,
                            },
                          },
                        }}
                      />
                    </div>
                  </>
                )}
            </div>
            <div className="workflow-status-inner-main-content-chart-with-title-single">
              {NetworkUsageChart.datasets &&
                NetworkUsageChart.datasets.length > 0 &&
                NetworkUsageChart.datasets[0].data &&
                NetworkUsageChart.datasets[0].data.length > 0 && (
                  <>
                    <h5>Network Usage</h5>
                    <div className="workflow-status-inner-main-content-chart-with-title-single-chart">
                      <LineChartWithPointWorkflow
                        data={{
                          labels: NetworkUsageChart.labels,
                          datasets: NetworkUsageChart.datasets,
                        }}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                          plugins: {
                            legend: {
                              display: false,
                            },
                            tooltip: {
                              display: true,
                            },
                          },
                          scales: {
                            x: {
                              display: false,
                              grid: {
                                display: true,
                                offset: false,
                              },
                              ticks: {
                                align: "center",
                              },
                            },
                            y: {
                              display: false,
                              grid: {
                                display: false,
                              },
                            },
                          },
                          elements: {
                            point: {
                              radius: 0,
                            },
                          },
                        }}
                      />
                    </div>
                  </>
                )}
            </div>
          </div>
        </div>
      </div>
      {supportShowModel && (
        <SupportModel
          relatedToLabel={NewMachineInfo?.name}
          case_Type={"Data Factory"}
          user_Type={Userdata?.associationtype}
          ass_Id={NewMachineInfo.ID}
          ass_Type={"Machine"}
          show={supportShowModel}
          onHide={() => setSupportShowModel(false)}
        />
      )}
    </div>
  );
};

export default WorkFlowStatusModel;
